// Dependency-free on purpose: the filters reducer imports these at store
// creation, before any config is loaded (type-only imports, no runtime cycle).
import type { InsightValue, TimeFrameValue } from 'common/types';

/**
 * Explore default fallbacks, used when the applicationConfigurations entries
 * (see lib/exploreDefaults.ts) are missing, invalid or not loaded yet.
 * Decision (Miller, Nov 3, 2026): Explore defaults to Hottest + 7 days for
 * every casino, including insight casinos (previously 24h for insight casinos).
 */
export const EXPLORE_DEFAULT_INSIGHT_FALLBACK = 'return' as InsightValue; // Hottest Slots (RTP)
export const EXPLORE_DEFAULT_TIMEFRAME_FALLBACK = 'weeks1' as TimeFrameValue; // 7d, casinos without insightInstance
export const EXPLORE_DEFAULT_TIMEFRAME_INSIGHT_CASINO_FALLBACK = 'weeks1' as TimeFrameValue; // 7d, insightInstance casinos (was 24h before Nov 3, 2026)
